export const translations = {
  English: {
    MCBWI: "Myanmar City Bonded Warehouse & Industrial Co., Ltd",
    ThanlyinIndustrialAndCommercialPark:
      "Thanlyin Industrial & Commercial Park",
    HeroSectionContent:
      " Delivering top-notch bonded warehouse solutions and industrial facilities across Myanmar.",
    ViewProject: "View Project",
    AboutMCBWI: "About MCBWI",
    AboutMCBWIParagraph:
      "With years of experience in the bonded warehouse and industrial sector, we provide top-tier solutions tailored to your needs.",
    LearnMore: "Learn More",
    OurProjects: "Our Projects",
    ContactUs: "Contact Us",
    GoldenGateTower: "Room No.6, Golden Gate Tower,",
    UpperPazuntaung: "Upper Pazuntaung",
    Mingalartaungnyunt: "Mingalartaungnyunt, Yangon, Myanmar.",
    Ph1: "(+959) 5102970",
    Ph2: "(+959) 5013687",
    Sitemap: "Sitemap",
    Home: "Home",
    OurProject: "Our Project",
    Contact: "Contact",
    Overview: "Overview",
    OverviewTexts: [
      "Myanmar City Bonded Warehouse and Industrial (MCBWI) Company have pleasure to offers to local or foreign industrialist, investors, and importers/exporters in Yangon, Myanmar.",
      "With a total over 50 acres (60.hectares) of land area, the property is located in Yangon No.2 Express Way, 10 kilometers from Yangon Thilawa Port and Thilawa Special Economic Zone (SEZ) and 30 minutes drive from Yangon downtown business and shopping centers and international standard five stars and four stars hotels, which is also only 30 kilometers from Yangon International Airport.",
      "We'll provide electricity supply, telecommunication, internet access, 24 hours CCTV monitoring on security and maintenance of the industrial and commercial zone keeping cleanliness as well as green environment.",
      "We're welcome all industrialist, investors, importers/exporters far and near come to make business in this most perfect and promising industrial and commercial zone, we're sincerely hoped that entrepreneurs who make investment in this zone will be getting benefits in long term.",
    ],
    MasterPlan: "Master Plan",
    TwoDMP: "2D Master Plan",
    ThreeDMP: "3D Master Plan",
    Details: "Details",

    detailItems: [
      {
        title: "Strategic Location",
        description:
          "Situated on Yangon-Thilwa No-2 Highway, (6 Lane Express way) in Thanlyin Township, Southern Yangon Region.",
      },
      {
        title: "Labor & Employment Synergy",
        description:
          "Serves a population pool of 260,000+ in Thanlyin Township and 930,000+ in Dagon Seikkan Port New City, with access to skilled labor from Thilawa, Kayan, and Three Pagodas Towns, fostering employment opportunities for local communities.",
      },
      {
        title: "Land Ownership",
        description:
          "Industrial / Commercial land category eligible for long-term land use rights (Grant).",
      },
      {
        title: "Power Supply Assurance",
        description:
          "Guaranteed stable and sufficient electricity for industrial operations",
      },
      {
        title: "Compliance & Sustainability",
        description:
          "Assists businesses in obtaining Myanmar Investment Commission (MIC) certifications while ensuring adherence to environmental regulations.",
      },
      {
        title: "24/7 Security",
        description:
          "Round-the-clock CCTV surveillance and professional security patrols.",
      },
      {
        title: "Environmental Maintenance",
        description:
          "Dedicated teams ensure cleanliness, sanitation, and lush green landscapes.",
      },
      {
        title: "Deep-Sea Port Advantage",
        description:
          "Proximity to Thilawa Deep-Sea Port enables rapid container handling for international vessels (reduced time/cost).",
      },
      {
        title: "Regional Logistics Network",
        description:
          "24-hour freight access to all industrial zones in Yangon Region via heavy-duty container trucks.",
      },
      {
        title: "Bonded Warehouse Services",
        description:
          "Streamlined customs clearance, storage, and distribution solutions for import/export businesses.",
      },
      {
        title: "Flexible Partnerships",
        description:
          "- Full land purchase (permanent ownership) - Long-term leasing - Joint ventures for technology transfer and regional employment growth.",
      },
      {
        title: "Insurance Solutions",
        description:
          "Connects enterprises with global/local insurers for customized coverage on factories, machinery, and raw materials.",
      },
    ],
    ProjectDesigns: "Project Designs",
    ProjectLocation: "Project Location",
    CurrentStatus: "Current Status",
    TravelTimes: "Travel Times",
    FromHrMin: "1 hr 15 min",
    From: "From Thilawa SEZ Zone",
    ToHrMin: "0 hr 15 min",
    To: "To Yangon International Airport",

    home: "Home",
    ourProjects: "Our Projects",
    contact: "Contact Us",
    projects: "Projects",
    thanlyin: "Thanlyin Industrial & Commercial Park",
    aboutUs: "About Us",
    English: "English",
    Burmese: "Burmese",
    Chinese: "Chinese",
    GetInTouch: "GET IN TOUCH",
    SendUsAnEnquiry: "SEND US AN ENQUIRY",
    visitUs: "VISIT US",
    callUs: "CALL US",
    emailUs: "EMAIL US",
    FullName: "Full Name",
    email: "E-mail",
    contactNo: "Contact No.",
    company: "Your Company / Organization",
    message: "Write down your message",
    sendMessage: "Send Message",
    Language: "Language",
    Welcome: "Welcome",
    WelcomeP1:
      "Welcome to Myanmar City Bonded Warehouse & Industrial Co., Ltd., a trusted name in the bonded warehouse and industrial sector. With years of experience, we pride ourselves on delivering top-tier, tailored solutions to meet the diverse needs of our clients.",
    WelcomeP2:
      "We are committed to excellence and innovation in everything we do.",
    established: "Established",
    registration: "Registration",
    location: "Location",
    establishedDate: "3 July 2018",
    registrationNumber: "Company Registration No. 104104746",
    locationAddress:
      "Room No. 6, Golden Gate Tower, Upper Pazuntaung, Mingalartaungnyunt, Yangon, Myanmar",
    OurMission: "Our Mission",
    OurMissionP1:
      "We are dedicated to fostering growth and providing exceptional infrastructure and services to industrialists, investors, and importers/exporters.",
    OurMissionP2:
      "Our goal is to create a thriving hub where businesses can flourish in a secure, modern, and sustainable setting.",
    Invitation: "Join Us",
    InvitationP1:
      "We warmly invite industrialists, investors, and entrepreneurs from near and far to join us in this promising industrial and commercial zone. We firmly believe that those who invest in the Thanlyin Industrial & Commercial Park will reap long-term benefits and contribute to the economic growth of Yangon, Myanmar.",
    InvitationP2:
      "At Myanmar City Bonded Warehouse & Industrial Co., Ltd., we are more than just a service provider—we are your partner in success. Come explore the opportunities awaiting you at Thanlyin Industrial & Commercial Park, and let us help you build a prosperous future.",
    ContactUsToday: "Contact Us Today",
  },
  Burmese: {
    MCBWI:
      "မြန်မာစီးတီးဘွန်ဒက်သိုလှောင်ခန်းနှင့် စက်မှုလုပ်ငန်း ကုမ္ပဏီလီမိတက်",
    ThanlyinIndustrialAndCommercialPark: "သန်လျင်စက်မှုနှင့်ကုန်သွယ်ရေးဇုန်",
    HeroSectionContent:
      "မြန်မာနိုင်ငံတစ်ဝှမ်းတွင် အဆင့်မီ သိုလှောင်ခန်းဝန်ဆောင်မှုများနှင့် စက်မှုဇုန်အဆောက်အအုံများကို ဖန်တီးပေးနေပါသည်။",
    ViewProject: "စီမံကိန်းကိုကြည့်ရှုရန်",
    AboutMCBWI: "MCBWI အကြောင်း",
    AboutMCBWIParagraph:
      "သိုလှောင်ခန်းနှင့် စက်မှုဇုန်လုပ်ငန်းများတွင် နှစ်ပေါင်းများစွာ အတွေ့အကြုံရှိသည့် ကျွန်ုပ်တို့သည် သင့်လိုအပ်ချက်များနှင့် ကိုက်ညီသော အဆင့်မီဝန်ဆောင်မှုများကို ပေးစွမ်းလျက်ရှိပါသည်။",
    LearnMore: "ပိုမိုလေ့လာရန်",
    OurProjects: "ကျွန်ုပ်တို့၏ စီမံကိန်းများ",
    ContactUs: "ဆက်သွယ်ရန်",

    GoldenGateTower: "Golden Gate Tower အခန်းအမှတ် (၆)၊",
    UpperPazuntaung: "အထက်ပုဇွန်တောင်လမ်း၊",
    Mingalartaungnyunt:
      "မင်္ဂလာတောင်ညွန့်မြို့နယ်၊ ရန်ကုန်မြို့",
    Ph1: "(+၉၅၉) ၅၁၀၂၉၇၀",
    Ph2: "(+၉၅၉) ၅၀၁၃၆၈၇",
    Sitemap: "ဆိုဒ်မြေပုံ",
    Home: "ပင်မစာမျက်နှာ",
    OurProject: "ကျွန်ုပ်တို့၏ စီမံကိန်းများ",
    Contact: "ဆက်သွယ်ရန်",
    Overview: "အကျဉ်းချုပ်",
    OverviewTexts: [
      "မြန်မာစီးတီးဘွန်ဒက် သိုလှောင်ခန်းနှင့် စက်မှုလုပ်ငန်း (MCBWI) ကုမ္ပဏီသည် ရန်ကုန်ရှိ ပြည်တွင်းပြည်ပ စက်မှုလုပ်ငန်းရှင်များ၊ ရင်းနှီးမြှုပ်နှံသူများနှင့် သွင်းကုန်/ထုတ်ကုန်လုပ်ငန်းရှင်များအား ဝန်ဆောင်မှုများ ပေးအပ်ရန် ဝမ်းမြောက်စွာ ကမ်းလှမ်းပါသည်။",
      "စုစုပေါင်း ဧက ၅၀ ကျော် (ဟက်တာ ၆၀) ကျယ်ဝန်းသော ဤအဆောက်အအုံသည် ရန်ကုန် အမြန်လမ်းပေါ်တွင် တည်ရှိပြီး ရန်ကုန်သီလဝါဆိပ်ကမ်းနှင့် သီလဝါအထူးစီးပွားရေးဇုန် (SEZ) မှ ၁၀ ကီလိုမီတာ၊ ရန်ကုန်မြို့လယ်ရှိ စီးပွားရေးနှင့် ဈေးဝယ်စင်တာများနှင့် အပြည်ပြည်ဆိုင်ရာ အဆင့်မီ ကြယ်ငါးပွင့်နှင့် ကြယ်လေးပွင့်ဟိုတယ်များမှ ၃၀ မိနစ်သာ မောင်းနှင်သည့်အကွာအဝေးတွင် တည်ရှိပါသည်။ ထို့အပြင် ရန်ကုန်အပြည်ပြည်ဆိုင်ရာလေဆိပ်မှ ၃၀ ကီလိုမီတာသာ ကွာဝေးပါသည်။",
      "ကျွန်ုပ်တို့သည် လျှပ်စစ်ဓာတ်အား ဖြန့်ဖြူးခြင်း၊ ဆက်သွယ်ရေးနှင့် အင်တာနက် ဝန်ဆောင်မှုများ၊ ၂၄ နာရီ CCTV စောင့်ကြည့်လည်ပတ်ခြင်း၊ လုံခြုံရေးနှင့် စက်မှုနှင့်ကုန်သွယ်ရေးဇုန်၏ သန့်ရှင်းမှုနှင့် စိမ်းလန်းသောပတ်ဝန်းကျင်ကို ထိန်းသိမ်းခြင်းတို့ကို ဆောင်ရွက်ပေးသွားမည်ဖြစ်ပါသည်။",
      "ကျွန်ုပ်တို့သည် အနီးအဝေးမရွေး စက်မှုလုပ်ငန်းရှင်များ၊ ရင်းနှီးမြှုပ်နှံသူများ၊ သွင်းကုန်/ထုတ်ကုန်လုပ်ငန်းရှင်များအား ဤအပြည့်စုံဆုံးနှင့် အလားအလာအကောင်းဆုံး စက်မှုနှင့်ကုန်သွယ်ရေးဇုန်တွင် စီးပွားရေးလုပ်ကိုင်ရန် ကြိုဆိုပါသည်။ ဤဇုန်တွင် ရင်းနှီးမြှုပ်နှံမည့် စီးပွားရေးလုပ်ငန်းရှင်များအနေဖြင့် ရေရှည်တွင် အကျိုးအမြတ်များ ရရှိစေရန် ကျွန်ုပ်တို့၏ စိတ်ရင်းအမှန်ဖြင့် မျှော်လင့်ပါသည်။",
    ],
    MasterPlan: "မဟာဗျူဟာစီမံကိန်း",
    TwoDMP: "2D မဟာဗျူဟာစီမံကိန်း",
    ThreeDMP: "3D မဟာဗျူဟာစီမံကိန်း",

    Details: "အသေးစိတ်အချက်အလက်များ",

    detailItems: [
      {
        title: "မဟာဗျူဟာကျသည့်တည်နေရာ",
        description:
          "ရန်ကုန်တိုင်းဒေသကြီး၊ သန်လျင်မြို့နယ်၊ ရန်ကုန်-သီလဝါ အမှတ်(၂)အမြန်လမ်း (၆ လမ်းသွားလမ်းမကြီး) တွင် တည်ရှိပါသည်။",
      },
      {
        title: "လုပ်သားအင်အားနှင့် အလုပ်အကိုင်အခွင့်အလမ်းများ",
        description:
          "သန်လျင်မြို့နယ်မှ လူဦးရေ ၂၆၀,၀၀၀ အထက်နှင့် ဒဂုံဆိပ်ကမ်းမြို့သစ်မှ ၉၃၀,၀၀၀ အထက်အထိ လုပ်သားအင်အား ရရှိပြီး သီလဝါ၊ ကရင်၊ ရွှေစည်းခုံ ဒေသများမှ အရည်အချင်းပြည့်ဝသော လုပ်သားများကို ရရှိနိုင်ပါသည်။",
      },
      {
        title: "မြေယာပိုင်ဆိုင်မှုအခွင့်အရေး",
        description:
          "စက်မှု/ကုန်သွယ်ရေး မြေအမျိုးအစားအား ရေရှည်အသုံးပြုခွင့် (ဂရန်) ရရှိနိုင်ပါသည်။",
      },
      {
        title: "လျှပ်စစ်ဓာတ်အား အာမခံချက်",
        description:
          "စက်မှုလုပ်ငန်းများအတွက် တည်ငြိမ်ပြီး လုံလောက်သော လျှပ်စစ်ဓာတ်အား ရရှိစေပါသည်။",
      },
      {
        title: "စည်းမျဉ်းနှင့် ရေရှည်တည်တံ့မှု",
        description:
          "မြန်မာနိုင်ငံရင်းနှီးမြှုပ်နှံမှုကော်မရှင် (MIC) လက်မှတ်ရရှိရန် ကူညီပေးခြင်းနှင့် သဘာဝပတ်ဝန်းကျင် စည်းမျဉ်းများနှင့်အညီ လိုက်နာမှုကို အာမခံပါသည်။",
      },
      {
        title: "၂၄ နာရီ လုံခြုံရေး",
        description:
          "နေ့ညမပြတ် CCTV ကြည့်ရှုစောင့်ကြပ်ခြင်းနှင့် ပရော်ဖက်ရှင်နယ် လုံခြုံရေးတပ်ဖွဲ့များ။",
      },
      {
        title: "ပတ်ဝန်းကျင်ထိန်းသိမ်းရေး",
        description:
          "သန့်ရှင်းမှု၊ ကျန်းမာရေးနှင့် စိမ်းလန်းသော ပတ်ဝန်းကျင်ကို ထိန်းသိမ်းရန် အထူးအဖွဲ့များ။",
      },
      {
        title: "ပင်လယ်နက်ဆိပ်ကမ်း အကျိုးကျေးဇူး",
        description:
          "သီလဝါပင်လယ်နက်ဆိပ်ကမ်းနှင့် နီးကပ်စွာတည်ရှိခြင်းဖြင့် နိုင်ငံတကာသင်္ဘောများအတွက် ကွန်တိန်နာကိစ္စရပ်များ မြန်ဆန်စွာ ဆောင်ရွက်နိုင်ပါသည်။ (အချိန်နှင့်ကုန်ကျစရိတ် သက်သာခြင်း)",
      },
      {
        title: "ဒေသအတွင်းသယ်ယူပို့ဆောင်ရေးကွန်ရက်",
        description:
          "ကွန်တိန်နာကားများဖြင့် ရန်ကုန်တိုင်းရှိ စက်မှုဇုန်အားလုံးသို့ ၂၄နာရီ ကုန်စည်ပို့ဆောင်ရေး ဝန်ဆောင်မှု။",
      },
      {
        title: "သိုလှောင်ခန်း ဝန်ဆောင်မှုများ",
        description:
          "သွင်းကုန်/ထုတ်ကုန်လုပ်ငန်းများအတွက် သက်တောင့်သက်သာရှိသော ကုန်သွယ်ရေးလုပ်ငန်းစဉ်များ၊ သိုလှောင်ရေးနှင့် ဖြန့်ဖြူးရေး ဝန်ဆောင်မှုများ။",
      },
      {
        title: "လိုက်လျောညီထွေဖြစ်သော မိတ်ဖက်ပြုလုပ်မှုများ",
        description:
          "မြေယာအပြည့်အဝဝယ်ယူခြင်း (အမြဲတမ်းပိုင်ဆိုင်ခွင့်) ၊ ရေရှည်ငှားရမ်းခြင်း၊ နည်းပညာလွှဲပြောင်းခြင်းနှင့် ဒေသအလုပ်အကိုင်တိုးတက်ရေးအတွက် ပူးပေါင်းလုပ်ကိုင်ခြင်း။",
      },
      {
        title: "အာမခံဖြေရှင်းချက်များ",
        description:
          "စက်ရုံများ၊ စက်ပစ္စည်းများနှင့် ကုန်ကြမ်းများအတွက် စိတ်ကြိုက်အာမခံချက်များရရှိရန် ကမ္ဘာလုံးဆိုင်ရာ/ဒေသဆိုင်ရာ အာမခံကုမ္ပဏီများနှင့် ချိတ်ဆက်ပေးခြင်း။",
      },
    ],
    ProjectDesigns: "စီမံကိန်းဒီဇိုင်းများ",
    ProjectLocation: "စီမံကိန်းတည်နေရာ",
    CurrentStatus: "လက်ရှိအခြေအနေ",
    TravelTimes: "ကြာချိန်",
    FromHrMin: "၁ နာရီ ၁၅ မိနစ်",
    From: "သီလဝါ အထူးစီးပွားရေးဇုန်မှ",
    ToHrMin: "၁၅ မိနစ်",
    To: "ရန်ကုန်အပြည်ပြည်ဆိုင်ရာလေဆိပ်သို့",
    home: "မူလစာမျက်နှာ",
    ourProjects: "စီမံကိန်းများ",
    contact: "ဆက်သွယ်ရန်",
    projects: "စီမံကိန်းများ",
    thanlyin: "သန်လျင်စက်မှုဇုန်နှင့် ကုန်သွယ်ရေးဧရိယာ",
    aboutUs: "ကျွန်ုပ်တို့အကြောင်း",

    English: "အင်္ဂလိပ်",
    Burmese: "ဗမာ",
    Chinese: "တရုတ်",
    GetInTouch: "ဆက်သွယ်လိုပါက",
    SendUsAnEnquiry: "ကျွန်ုပ်တို့ထံမေးမြန်းစာပို့ရန်",
    visitUs: "လာရောက်လည်ပတ်ရန်",
    callUs: "ဖုန်းဆက်ရန်",
    emailUs: "အီးမေးလ်ပို့ရန်",
    FullName: "အမည်",
    email: "အီးမေးလ်လိပ်စာ",
    contactNo: "ဆက်သွယ်ရန် ဖုန်းနံပါတ်",
    company: "သင့်ကုမ္ပဏီ/အဖွဲ့အစည်း အမည်",
    message: "သင့်စာကို ဤနေရာတွင် ရေးသားပါ",
    sendMessage: "ပေးပို့မည်",
    Language: "ဘာသာစကား",
    Welcome: "ကြိုဆိုပါတယ်",
    WelcomeP1:
      "မြန်မာစီးတီး ဘွန်ဒက်သိုလှောင်ခန်းနှင့် စက်မှုလုပ်ငန်း ကုမ္ပဏီလီမိတက်သို့ ကြိုဆိုပါသည်။ သိုလှောင်ခန်းနှင့် စက်မှုဇုန်လုပ်ငန်းများတွင် ယုံကြည်စိတ်ချရသော နာမည်တစ်ခုအဖြစ် နှစ်ပေါင်းများစွာ အတွေ့အကြုံရှိသော ကျွန်ုပ်တို့သည် လုပ်ငန်းလိုအပ်ချက်များကို ဖြည့်ဆည်းပေးနိုင်သည့် အဆင့်မြင့် ဝန်ဆောင်မှုများပေးစွမ်းရန် ဂုဏ်ယူပါသည်။",
    WelcomeP2:
      "ကျွန်ုပ်တို့သည် လုပ်ဆောင်သမျှကိစ္စတိုင်းတွင် အရည်အသွေးပြည့်ဝမှုနှင့် အဆင့်မြင့်ဆန်းသစ်တီထွင်မှုတို့ကို အပြည့်အဝ ဆောင်ရွက်လျက်ရှိပါသည်။",
    established: "တည်ထောင်သည့်နေ့",
    registration: "မှတ်ပုံတင်ခြင်း",
    location: "တည်နေရာ",
    establishedDate: "၂၀၁၈ ခုနှစ်၊ ဇူလိုင်လ ၃ ရက်",
    registrationNumber: "ကုမ္ပဏီမှတ်ပုံတင်အမှတ် - ၁၀၄၁၀၄၇၄၆",
    locationAddress:
      "Golden Gate Tower အခန်းအမှတ် (၆)， အထက်ပုဇွန်တောင်လမ်း၊ မင်္ဂလာတောင်ညွန့်မြို့နယ်၊ ရန်ကုန်မြို့",
    OurMission: "လုပ်ငန်းရည်ရွယ်ချက်",
    OurMissionP1:
      "ကျွန်ုပ်တို့သည် စက်မှုလုပ်ငန်းရှင်များ၊ ရင်းနှီးမြှုပ်နှံသူများနှင့် သွင်းကုန်/ထုတ်ကုန်လုပ်ငန်းရှင်များအား အဆင့်မီ အခြေခံအဆောက်အအုံများနှင့် ဝန်ဆောင်မှုများ ပေးအပ်ကာ ဖွံ့ဖြိုးတိုးတက်ရေး အားသွန်ခွန်စိုက် ဆောင်ရွက်လျက်ရှိပါသည်။",
    OurMissionP2:
      "ကျွန်ုပ်တို့၏ ရည်မှန်းချက်မှာ ခေတ်မီစွာဖြင့် ဘေးကင်းလုံခြုံပြီး ရေရှည်တည်တံ့သော ပတ်ဝန်းကျင်တွင် စီးပွားရေးလုပ်ငန်းများ ဖွံ့ဖြိုးစေမည့် အချက်အချာဗဟိုဌာနတစ်ခု ဖန်တီးရန်ဖြစ်ပါသည်။",
    Invitation: "ကျွန်ုပ်တို့နှင့်ပူးပေါင်းပါ",
    InvitationP1:
      "ကျွန်ုပ်တို့သည် အနီးအဝေးမှ စက်မှုလုပ်ငန်းရှင်များ၊ ရင်းနှီးမြှုပ်နှံသူများနှင့် စီးပွားရေးလုပ်ငန်းရှင်များအား ဤအလားအလာကောင်းသော စက်မှုနှင့်ကုန်သွယ်ရေးဇုန်တွင် ပူးပေါင်းရန် ဖိတ်ခေါ်အပ်ပါသည်။ သန်လျင်စက်မှုနှင့်ကုန်သွယ်ရေးဇုန်တွင် ရင်းနှီးမြှုပ်နှံမည့်သူများသည် ရေရှည်အကျိုးအမြတ်များရရှိမည်ဖြစ်ပြီး ရန်ကုန်မြို့၏ စီးပွားရေးဖွံ့ဖြိုးတိုးတက်မှုကို အထောက်အကူဖြစ်စေမည်ဟု ကျွန်ုပ်တို့ အခိုင်အမာယုံကြည်ပါသည်။",
    InvitationP2:
      "မြန်မာစီးတီး ဘွန်ဒက်သိုလှောင်ခန်းနှင့် စက်မှုလုပ်ငန်း ကုမ္ပဏီလီမိတက်သည် ဝန်ဆောင်မှုပေးသူထက် ပိုမိုသော - သင့်အောင်မြင်မှု၏ မိတ်ဆွေတစ်ယောက်ပါ။ သန်လျင်စက်မှုနှင့်ကုန်သွယ်ရေးဇုန်တွင် သင့်အတွက်စောင့်မျှော်နေသော အခွင့်အလမ်းများကို ရှာဖွေပြီး ပိုမိုကောင်းမွန်သော အနာဂတ်တစ်ခုတည်ဆောက်ရန် ကျွန်ုပ်တို့က ကူညီပါမည်။",
    ContactUsToday: "အခု ဆက်သွယ်လိုက်ပါ",
  },
  Chinese: {
    MCBWI: "缅甸城市保税仓库及工业有限公司",
    ThanlyinIndustrialAndCommercialPark: "丹林工商业区",
    HeroSectionContent:
      "在缅甸全国范围内提供一流的保税仓库解决方案和工业设施。",
    ViewProject: "查看项目",
    AboutMCBWI: "关于MCBWI",
    AboutMCBWIParagraph:
      "凭借在保税仓库和工业领域多年的经验，我们为您提供量身定制的高端解决方案",
    LearnMore: "了解更多",
    OurProjects: "我们的项目",
    ContactUs: "联系我们",
    GoldenGateTower: "金门大厦6号房间",
    UpperPazuntaung: "上部巴遵塘路",
    Mingalartaungnyunt: "缅甸仰光市敏加拉当纽区",
    Ph1: "(+959) 5102970",
    Ph2: "(+959) 5013687",
    Sitemap: "网站地图",
    Home: "首页",
    OurProject: "我们的项目",
    Contact: "联系我们",
    Overview: "简介",
    OverviewTexts: [
      "缅甸城市保税仓库及工业园区公司 (MCBWI) 荣幸地为在缅甸仰光的国内外工业家、投资者及进出口商提供优质服务。",
      "该物业总占地面积超过50英亩（60公顷），位于仰光二号高速公路沿线，距离仰光迪拉瓦港口和迪拉瓦经济特区（SEZ）仅10公里，距仰光市中心商业区和购物中心以及国际标准的五星级和四星级酒店仅30分钟车程，同时距离仰光国际机场仅30公里。",
      "我们将提供电力供应、电信服务、网络接入、24小时闭路电视监控安保服务，并维护工业园区和商业区的清洁以及绿色环境。",
      "我们热忱欢迎各地工业家、投资者及进出口商前来这个最完善且最具发展潜力的工商园区开展业务。我们真诚地希望在本园区投资的企业家能够获得长期收益。",
    ],
    MasterPlan: "总体规划",
    TwoDMP: "2D 总体规划",
    ThreeDMP: "3D 总体规划",
    Details: "详情",
    detailItems: [
      {
        title: "战略位置",
        description:
          "位于仰光省淡汶镇区仰光-迪拉瓦2号高速公路（6车道快速路）。",
      },
      {
        title: "劳动力与就业协同",
        description:
          "可利用淡汶镇区26万+人口及达贡港新城区93万+劳动力资源，并能获取来自迪拉瓦、高烟和三塔地区的熟练工人，为当地社区创造就业机会。",
      },
      {
        title: "土地所有权",
        description: "工业/商业用地类别，可获得长期土地使用权（批文）。",
      },
      {
        title: "电力供应保障",
        description: "为工业运营提供稳定充足的电力保障",
      },
      {
        title: "合规与可持续发展",
        description:
          "协助企业获得缅甸投资委员会（MIC）认证，同时确保遵守环保法规。",
      },
      {
        title: "24/7全天候安保",
        description: "24小时闭路电视监控和专业安保巡逻。",
      },
      {
        title: "环境维护",
        description: "专业团队负责清洁卫生和绿化景观维护。",
      },
      {
        title: "深水港优势",
        description:
          "毗邻迪拉瓦深水港，可快速处理国际船舶集装箱（减少时间/成本）。",
      },
      {
        title: "区域物流网络",
        description: "通过重型集装箱卡车实现24小时连通仰光地区所有工业区。",
      },
      {
        title: "保税仓库服务",
        description: "为进出口企业提供简化的清关、仓储和分销解决方案。",
      },
      {
        title: "灵活合作模式",
        description:
          "- 全地块购买（永久产权） - 长期租赁 - 技术转让与区域就业增长合资合作。",
      },
      {
        title: "保险解决方案",
        description:
          "为企业对接全球/本地保险公司，提供工厂、机械和原料的定制保险方案。",
      },
    ],
    ProjectDesigns: "项目设计",
    ProjectLocation: "项目位置",
    CurrentStatus: "当前状态",

    TravelTimes: "行程时间",
    FromHrMin: "1小时15分钟",
    From: "从迪拉瓦经济特区出发",
    ToHrMin: "15分钟",
    To: "至仰光国际机场",
    home: "首页",
    ourProjects: "我们的项目",
    contact: "联系我们",
    projects: "项目",
    thanlyin: "丹林工商业区",
    aboutUs: "关于我们",
    GetInTouch: "取得联系",
    SendUsAnEnquiry: "发送询问",
    visitUs: "访问我们",
    callUs: "致电我们",
    emailUs: "电邮我们",
    FullName: "姓名",
    email: "电子邮箱",
    contactNo: "联系电话",
    company: "公司/机构名称",
    message: "请输入您的留言内容",
    sendMessage: "发送信息",
    Language: "语言",
    Welcome: "欢迎",
    WelcomeP1:
      "欢迎莅临缅甸城市保税仓库及工业有限公司。作为保税仓库和工业领域值得信赖的品牌，我们凭借多年的行业经验，自豪地为客户提供高端定制化解决方案，满足多样化需求。",
    WelcomeP2: "我们致力于在所做的一切工作中追求卓越与创新。",
    established: "成立时间",
    registration: "注册信息",
    location: "所在地",
    establishedDate: "2018年7月3日",
    registrationNumber: "公司注册号：104104746",
    locationAddress: "缅甸仰光市敏加拉当纽镇区，上巴遵塘路，金门大厦6号房间",
    OurMission: "我们的使命",
    OurMissionP1:
      "我们致力于为工业家、投资者及进出口商提供卓越的基础设施和服务，全力推动产业发展。",
    OurMissionP2:
      "我们的目标是打造一个安全、现代且可持续的商业枢纽，助力企业蓬勃发展。",
    Invitation: "加入我们",
    InvitationP1:
      " 我们诚挚邀请各地工业家、投资者和企业家加入这个充满潜力的工商园区。我们坚信，投资淡汶工商园区的伙伴不仅将获得长期回报，更将为缅甸仰光的经济发展做出贡献。",
    InvitationP2:
      "缅甸城市保税仓库及工业有限公司不仅是服务提供商，更是您成功的合作伙伴。快来探索淡汶工商园区的无限商机，让我们携手共创繁荣未来。",
    ContactUsToday: "立即联系我们",
  },
};
